import React, { useState, useCallback } from "react";
import Slider from "react-slick/lib";
import settings from "../../shared/SliderSettings";

import placeholder_1 from "../../../../../assets/images/landing/placeholder-images/placeholder_1.jpg";
import placeholder_2 from "../../../../../assets/images/landing/placeholder-images/placeholder_2.jpg";
import placeholder_3 from "../../../../../assets/images/landing/placeholder-images/placeholder_3.jpg";
import placeholder_4 from "../../../../../assets/images/landing/placeholder-images/placeholder_4.jpg";
import placeholder_5 from "../../../../../assets/images/landing/placeholder-images/placeholder_5.jpg";
import placeholder_6 from "../../../../../assets/images/landing/placeholder-images/placeholder_6.jpg";
import placeholder_7 from "../../../../../assets/images/landing/placeholder-images/placeholder_7.jpg";
import placeholder_8 from "../../../../../assets/images/landing/placeholder-images/placeholder_8.jpg";
import placeholder_9 from "../../../../../assets/images/landing/placeholder-images/placeholder_9.jpg";
import placeholder_10 from "../../../../../assets/images/landing/placeholder-images/placeholder_10.jpg";
import placeholder_11 from "../../../../../assets/images/landing/placeholder-images/placeholder_11.jpg";
import placeholder_12 from "../../../../../assets/images/landing/placeholder-images/placeholder_12.jpg";

function SliderPage() {
  const [images, setImages] = useState([
    placeholder_1,
    placeholder_2,
    placeholder_3,
    placeholder_4,
    placeholder_5,
    placeholder_6,
    placeholder_7,
    placeholder_8,
    placeholder_9,
    placeholder_10,
    placeholder_11,
    placeholder_12
  ]);

  const renderImages = () => {
    let result = [];
    for (let i = 0; i < images.length; i++) {
      let elem;
      if (i % 3 !== 0 && i <= images.length - 2) {
        elem = (
          <div
            key={`${images[i]}-${images[i + 1]}`}
            className="pw-slider-img-container"
          >
            <div className="pw-slider-img-container--double">
              <img
                src={images[i]}
                alt="placeholder-product-image"
                width={"240px"}
                height={"240px"}
              />
              <img
                src={images[i + 1]}
                alt="placeholder-product-image"
                width={"240px"}
                height={"240px"}
              />
            </div>
          </div>
        );
        i++;
      } else {
        elem = (
          <div key={`${images[i]}`} className="pw-slider-img-container">
            <img
              src={images[i]}
              alt="placeholder-product-image"
              width={"480px"}
              height={"480px"}
            />
          </div>
        );
      }

      result.push(elem);
    }
    return result;
  };

  const renderImagesCallback = useCallback(renderImages, [images]);

  return (
    <div className="pw-slider-page-container">
      <Slider {...settings}>{renderImagesCallback()}</Slider>
    </div>
  );
}

export default SliderPage;
